// DEV-AI-015: the one place the backend address is read. Every screen and service imports API_URL from here.
// If the address is missing or invalid, API_URL is '' and CONFIG_ERROR holds the message; index.js then shows a
// configuration error page instead of the app, so nothing can reach any backend by accident.
import { validateApiUrl } from './utils/apiConfig';

const result = validateApiUrl(process.env.REACT_APP_API_URL);

export const API_URL = result.url;
export const CONFIG_ERROR = result.error;
